import { ref } from 'vue'

const houseId = ref( '98751' )

const selectedArea = ref( null )

const houseFloorsCount = ref( undefined )

export { houseId, selectedArea, houseFloorsCount }